module.exports = __webpack_public_path__ + "img/corazon.07570d8e.svg";